import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { useSmsLogsList } from '@/features/logs-management/sms-logs/hooks/useSmsLogsList';
import { SMSLogsTable } from '@/features/logs-management/sms-logs/table';
import { Translation } from '@/hoslog-intl';
import { SmsIcon } from '@/icons';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['phoneNumber', 'message', 'createdDate', 'status', 'nickname']),
  desc: z.boolean(),
});

const smsLogsSchema = z
  .object({
    sort: z
      .preprocess((val) => {
        if (typeof val === 'string') {
          try {
            return JSON.parse(val);
          } catch {
            return undefined;
          }
        }
        return val;
      }, z.array(sortItemSchema))
      .optional(),

    createdDate: z.string().optional(),

    q: z
      .any()
      .transform((val) => (val == null ? undefined : String(val)))
      .optional(),

    status: z
      .string()
      .transform((val) => val.split(','))
      .pipe(z.array(z.enum(['ACTIVE', 'INACTIVE'])))
      .optional(),

    page: z.coerce.number().positive().catch(0),
    fetch: z.coerce.number().positive().max(100).catch(10),
  })
  .passthrough();

export const Route = createFileRoute('/(app)/logs-management/sms-logs/')({
  loader: () => {
    return {
      crumb: <CrumbTitle id="logsManagement.smsLogs.crumb.smsLogs" icon={SmsIcon} />,
      title: <Translation id="logsManagement.smsLogs.crumb.smsLogs" />,
    };
  },

  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => smsLogsSchema.parse(search),
});

function RouteComponent() {
  const { smsLogs, isLoading, pagination } = useSmsLogsList();
  return <SMSLogsTable data={smsLogs} isLoading={isLoading} pagination={pagination} />;
}
